import product1 from "./assets/1.png";
import product2 from "./assets/2.png";
import product3 from "./assets/3.png";
import product4 from "./assets/4.png";
import product5 from "./assets/5.png";
import product6 from "./assets/6.webp";
import product7 from "./assets/7.webp";
import product8 from "./assets/8.webp";

export const PRODUCTS = [
  {
    id: 1,
    productName: "IPhone",
    price: 1099.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Macbook Pro",
    price: 1999.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Canon M50 Camera",
    price: 499.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "WLS  Denim Jacket",
    price: 220.0,
    productImage: product4,
  },
  {
    id: 5,
    productName: "LED Light Strips",
    price: 20.0,
    productImage: product5,
  },
  {
    id: 6,
    productName: "SPECTRUM  T-SHIRT",
    price: 68.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: " SHIRT by GOLF WANG",
    price: 75.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "DON'T TRIP  HAT",
    price: 40.0,
    productImage: product8,
  },
];